import React, { useCallback, useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { ItemList } from 'v2/models';
import { AISearchFormFields } from 'v2/pages/DrmFeatures/AISearch/CreateAISearchModal/AISearchSchema';
import { CurrentStateFilterContext } from './currentStateFilterContext';

interface ICurrentItemListFormProps {
  children: React.ReactNode;
  onChange: (itemList: ItemList) => void;
  fieldName: any;
}

export const CurrentItemListForm = ({
  children,
  onChange,
  fieldName,
}: ICurrentItemListFormProps) => {
  const { watch, setValue } = useFormContext<AISearchFormFields>();
  const currentList = watch(fieldName) as unknown as ItemList;

  const setCurrentState: React.Dispatch<React.SetStateAction<ItemList>> =
    useCallback(
      (param) => {
        let newVal: ItemList;
        if (typeof param === 'function') {
          newVal = param(currentList);
        } else {
          newVal = param;
        }
        setValue(fieldName, currentList);
        onChange(newVal);
      },
      [currentList, onChange]
    );
  return (
    <CurrentStateFilterContext.Provider
      value={{ currentState: currentList, setCurrentState }}
    >
      {children}
    </CurrentStateFilterContext.Provider>
  );
};

export const useCurrentItemListForm = () => {
  return useContext(CurrentStateFilterContext);
};
